var XMLFile			= require('../xml/XMLFile'),
	Style			= require('./Style'),
	Font			= require('./Font'),
	Fill			= require('./Fill'),
	Border			= require('./Border'),
	NumberFormat	= require('./NumberFormat');

/**
 *
 * @class
 * @module style/Styles
 */
function Styles() {
	XMLFile.call(this, Styles.metadata);

	/* Microsoft Excel fix - specific fill that needs to be present */
	this.addFill({ type: 'none' }); // Add a default fill at index 0
	this.addFill({ type: 'gray125' }); // Needs to have index 1
	this.addStyle(Style.DEFAULT); // Apply base style to feed the hard-coded cellStyles and cellStyleXfs
}

Styles.prototype = Object.create(XMLFile.prototype);
Styles.prototype.constructor = Styles;

Styles.metadata = {
	filename: 'styles.xml',
	tag: 'styleSheet',
	root: true,
	attributes: [
		{
			name: 'xmlns',
			value: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main'
		},
		{
			name: 'xmlns',
			suffix: 'mc',
			value: 'http://schemas.openxmlformats.org/markup-compatibility/2006'
		}

		/*
		,
		{
			name: 'mc',
			suffix: 'Ignorable',
			value: 'x14ac x16r2 xr'
		},
		{
			name: 'xmlns',
			suffix: 'x14ac',
			value: 'http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac'
		},
		{
			name: 'xmlns',
			suffix: 'x16r2',
			value: 'http://schemas.microsoft.com/office/spreadsheetml/2015/02/main'
		},
		{
			name: 'xmlns',
			suffix: 'xr',
			value: 'http://schemas.microsoft.com/office/spreadsheetml/2014/revision'
		}
		*/
	],
	properties: [
		{
			id: 'numberFormats',
			tag: 'numFmts',
			attributes: [
				{
					id: 'count',
					name: 'count',
					value: 0
				}
			]
		},
		{
			id: 'fonts',
			tag: 'fonts',
			attributes: [
				{
					id: 'count',
					name: 'count',
					value: 0
				}
			]
		},
		{
			id: 'fills',
			tag: 'fills',
			attributes: [
				{
					id: 'count',
					name: 'count',
					value: 0
				}
			]
		},
		{
			id: 'borders',
			tag: 'borders',
			attributes: [
				{
					id: 'count',
					name: 'count',
					value: 0
				}
			]
		},
		{
			tag: 'cellStyleXfs',
			attributes: [
				{
					name: 'count',
					value: '1'
				}
			],
			properties: [
				{
					tag: 'xf',
					attributes: [
						{
							name: 'numFmtId',
							value: '0'
						},
						{
							name: 'fontId',
							value: '0'
						},
						{
							name: 'fillId',
							value: '0'
						},
						{
							name: 'borderId',
							value: '0'
						}
					]
				}
			]
		},
		{
			id: 'cellXfs',
			tag: 'cellXfs',
			attributes: [
				{
					id: 'count',
					name: 'count',
					value: 0
				}
			]
		},
		{
			tag: 'cellStyles',
			attributes: [
				{
					name: 'count',
					value: '1'
				}
			],
			properties: [
				{
					tag: 'cellStyle',
					attributes: [
						{
							name: 'name',
							value: 'Normal'
						},
						{
							name: 'xfId',
							value: '0'
						},
						{
							name: 'builtinId',
							value: '0'
						}
					]
				}
			]
		},
		{
			tag: 'dxfs',
			attributes: [
				{
					name: 'count',
					value: 0
				}
			]
		},
		{
			tag: 'tableStyles',
			attributes: [
				{
					name: 'count',
					value: 0
				},
				{
					name: 'defaultTableStyle',
					value: 'TableStyleMedium2'
				},
				{
					name: 'defaultPivotStyle',
					value: 'PivotStyleLight16'
				}
			]
		}
	]
};


/**
 * Adds the specified Style to the Styles class according to the
 * Style configuration. The method will return a Style object that
 * references Font, Fill, Border and an optional NumberFormat. If
 * some of the referenced Font, Fill, Border or NumberFormat objects
 * are not present yet, it will create them automatically, otherwise
 * it will re-use existing ones.
 *
 * The method ensures that particular Style combinations exist only
 * once and there are no duplicates.
 *
 * @param {Object} oData - Configuration object that defines the Style information
 * @param {Object} [oData.font] - Configuration object that defines the Font information
 * @param {string} [oData.font.name] - Name of the used Font i.E. 'Arial'
 * @param {string} [oData.font.size] - Preferred Font size i.E. '12'
 * @param {boolean} [oData.font.bold] - Defines the Font weight
 * @param {Object} [oData.fill] - Configuration object that defines the Fill information
 * @param {string} [oData.fill.color] - HEX string defining the color of the cell fill
 * @param {string} [oData.fill.type] - Defines the type of the fill i.E. 'none' or 'solid'
 * @param {Object} [oData.border] - Configuration object that defines the Border information
 * @param {Object|number} [oData.numberFormat] - Configuration object that defines the NumberFormat information
 * @param {string} [oData.numberFormat.format] - Formatting template that will be used
 * @param {Object} [oData.align] - Defines the text alignment within the cell
 * @param {string} [oData.align.horizontal] - Horizontal alignment
 * @param {string} [oData.align.vertical] - Vertical alignment
 * @param {number} [oData.align.indent] - Cell indentation
 * @param {boolean} [oData.quotePrefix] - Defines whether the style configuration should add a quotePrefix attribute
 * @returns {number} - The ID of the unique Style object that needs to be referenced
 */
Styles.prototype.addStyle = function(oData) {
	var style, fontId, fillId, borderId, numberFormatId;

	/* Add Font, Fill, Border and NumberFormat if needed */
	fontId = this.addFont(oData.font);
	fillId = this.addFill(oData.fill);
	borderId = this.addBorder(oData.border);

	/* Fallback to avoid custom NumberFormats that won't be used if oData.numberFormat is undefined */
	if (typeof oData.numberFormat === 'undefined') {
		oData.numberFormat = 0;
	}

	numberFormatId =
		NumberFormat._isBuiltin(oData.numberFormat) ? oData.numberFormat : this.addNumberFormat(oData.numberFormat);

	/* Create temporary Style */
	style = new Style();

	style.setFontId(fontId);
	style.setFillId(fillId);
	style.getBorderId(borderId);
	style.setNumberFormatId(numberFormatId);
	style.setAlignment(oData.align);
	style.setQuotePrefix(oData.quotePrefix);

	/* Add Style if not already present */
	return this._addToAggregation(style, this.cellXfs);
};


/**
 * Adds the specific item to the provided aggregation. This Method
 * should only be called by the library itself due to possible
 * failures. It automatically updates the count within the XML
 * representation of this aggregation.
 *
 * This method should only be used for Font, Fill, Border or
 * NumberFormat objects.
 *
 * @param {Font|Fill|Border|NumberFormat|Style} oNewItem - The item that needs to be appended to the aggregation
 * @param {Array} aAggregation - An array that represents the aggregation
 * @returns {number} - The zero-based index of the element after it was inserted
 * @private
 */
Styles.prototype._addToAggregation = function(oNewItem, aAggregation) {
	var count, i;

	i = -1;

	aAggregation.childs.forEach(function(existingItem, index, array) {
		if (existingItem.equals(oNewItem)) {
			i = index;
		}
	});

	if (i === -1) {
		aAggregation.addChild(oNewItem);
		count = aAggregation.childs.length;

		aAggregation.count.value = count;
		i = count - 1;
	}

	return i;
};


/**
 * This method adds a RGB color to the Styles collection that is
 * referenced by several Styles.
 *
 * If this particular color is already present, it will not add it a
 * second time.
 *
 * @param {string} sHexColor - HEX string representing a RGB color
 */
Styles.prototype.addColor = function(sHexColor) {
	var alreadyPresent;

	if (!this.colors) {
		this.addChild({
			id: 'colors',
			tag: 'colors',
			properties: [
				{
					id: 'mru',
					tag: 'mruColors'
				}
			]
		});
	}

	alreadyPresent = this.colors.mru.childs.some(function(color) {
		return color.rgb.value === 'FF' + sHexColor;
	});

	if (alreadyPresent) {
		return;
	}

	this.colors.mru.addChild({
		tag: 'color',
		attributes: [
			{
				id: 'rgb',
				name: 'rgb',
				value: 'FF' + sHexColor
			}
		]
	});
};


/**
 * This method adds a Font to the Styles collection that can be
 * referenced by several Styles. The Font is instantiated according
 * to the provided configuration object.
 *
 * If this particular Font is already present, it will not add it a
 * second time. This ensures that each referenced Font is unique
 * according to the criteria of Font#equals.
 *
 * The method returns the index which deals as an identifier for this
 * Font.
 *
 * @param {Object} oData - Configuration object for this Font
 * @returns {number} - The index of this Font used for reference by Style objects
 */
Styles.prototype.addFont = function(oData) {
	var oFont = new Font(oData);

	return this._addToAggregation(oFont, this.fonts);
};


/**
 * This method adds a Fill to the Styles collection that can be
 * referenced by several Styles. The Fill is instantiated according
 * to the provided configuration object.
 *
 * If this particular Fill is already present, it will not add it a
 * second time. This ensures that each referenced Fill is unique
 * according to the criteria of Fill#equals.
 *
 * The method returns the index which deals as an identifier for this
 * Fill.
 *
 * @param {Object} oData - Configuration object for this Fill
 * @returns {number} - The index of this Fill used for reference by Style objects
 */
Styles.prototype.addFill = function(oData) {
	var index, oFill;

	oFill = new Fill(oData);

	index = this._addToAggregation(oFill, this.fills);

	if (oFill.getFill() !== null) {
		this.addColor(oFill.getFill());
	}

	return index;
};


/**
 * This method adds a Border to the Styles collection that can be
 * referenced by several Styles. The Border is instantiated according
 * to the provided configuration object.
 *
 * If this particular Border is already present, it will not add it a
 * second time. This ensures that each referenced Border is unique
 * according to the criteria of Border#equals.
 *
 * The method returns the index which deals as an identifier for this
 * Border.
 *
 * @param {Object} oData - Configuration object for this Border
 * @returns {number} - The index of this Border used for reference by Style objects
 */
Styles.prototype.addBorder = function(oData) {
	var oBorder = new Border(oData);

	return this._addToAggregation(oBorder, this.borders);
};


/**
 * This method adds a NumberFormat to the Styles collection that can
 * be referenced by several Styles. The NumberFormat is instantiated
 * according to the provided configuration object.
 *
 * If this particular NumberFormat is already present, it will not
 * add it a second time. This ensures that each referenced
 * NumberFormat is unique according to the criteria of
 * NumberFormat#equals.
 *
 * The method returns the index which deals as an identifier for this
 * NumberFormat.
 *
 * @param {Object} oData - Configuration object for this NumberFormat
 * @returns {number} - The index of this NumberFormat used for reference by Style objects
 */
Styles.prototype.addNumberFormat = function(oData) {
	var index, numberFormat;

	numberFormat = new NumberFormat(oData);
	index = this._addToAggregation(numberFormat, this.numberFormats);

	numberFormat.setId(NumberFormat.ID_OFFSET + index);

	return numberFormat.getId();
};

module.exports = Styles;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/style/Styles.js
// module id = 30
// module chunks = 0